import React, { Component } from 'react';
import { connect } from 'react-redux';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import ExportingData from 'highcharts/modules/export-data';
import moment from 'moment';
import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css'
import GraphAnnotation from './../../../../../../containers/graphAnnotation.js';
import AnnotationsFactory from 'highcharts/modules/annotations';
AnnotationsFactory(Highcharts);
Exporting(Highcharts);
ExportingData(Highcharts);


class TeachingDaysToMasteryGraph extends Component {

    constructor(props) {
        super(props);        
        this.state = {            
            sliderMaxValue: null,
            sliderValue: 0,
            AnnotationLabel : [],
          };
        this.onSliderChange = this.onSliderChange.bind(this);
        this.setAnnotationState = this.setAnnotationState.bind(this);
      }

    componentDidMount = () => {
         this.highchartsHandler();
    }

    
    componentDidUpdate = () => {
        if(this.props.dataAnalytics !== null) {
            this.highchartsHandler();
        }
    }

    // This method will be sent to the child component
    setAnnotationState(AnnotationState) {
        let annotationLabel = []; 
        annotationLabel.push(AnnotationState);       
        this.setState({
            AnnotationLabel: annotationLabel
        },()=>this.highchartsHandler());
    }

    highchartsHandler = () => {
        let finalData = [];
        let targetId = [];
        let xAxisDate = [];
        // let FromDate = moment(this.props.FromDate, 'YYYY-MM-DD');
        // let ToDate = moment(this.props.ToDate, 'YYYY-MM-DD');
        // let diff = ToDate.diff(FromDate, 'days', false);
        // diff = diff + 1;
        let xAxisLabel = this.props.xAxisName === undefined ? 'Step Performance' : this.props.xAxisName;
        let yAxisLabel = this.props.yAxisName === undefined ? 'Date' : this.props.yAxisName;
        // let disableYaxislabel = this.props.disableYaxislabel;
        // let disableXaxislabel = this.props.disableXaxislabel;
        //let selectedProgram = this.props.selectedProgram;
        // let selectedProgram = this.props.graphTitle;        
        if (this.props.dataAnalytics !== null && this.props.dataAnalytics.data.patientSkillsAcquisitionGraphs.length > 0) {
            this.props.dataAnalytics.data.patientSkillsAcquisitionGraphs.map((obj, index) => {
                let dataObj = {}
                let targetData = [];
                let goaldataForDate = this.props.dataAnalytics.data.patientSkillsAcquisitionGraphs;
                for (let i = 0; i < goaldataForDate.length; i++) {
                    if(xAxisDate.indexOf(moment(goaldataForDate[i].dos).format('MM/DD/YYYY')) === -1)
                    {
                        xAxisDate.push(moment(goaldataForDate[i].dos).format('MM/DD/YYYY'));
                    }
                }

                if(targetId.indexOf(obj.targetId) === -1)
                {
                    let goaldata = this.props.dataAnalytics.data.patientSkillsAcquisitionGraphs.filter((op) => op.targetId === obj.targetId);
                    targetData = [];
                    for (let i = 0; i < goaldata.length; i++) {
                        dataObj['name'] = goaldata[i].targetName;
                        dataObj['targetId'] = goaldata[i].targetId;
                        targetId.push(goaldata[i].targetId);
                        if(xAxisDate.indexOf(moment(goaldata[i].dos).format('MM/DD/YYYY')) > -1)
                        {
                            let index = xAxisDate.indexOf(moment(goaldata[i].dos).format('MM/DD/YYYY'));
                            targetData[index] = parseFloat(goaldata[i].targetData);
                            // targetData.push(goaldata[i].targetData);
                        }
                    }

                    for(let j = 0; j < targetData.length; j++)
                    {
                        if(!targetData[j])
                        {
                            targetData[j] = null;
                        }
                    }
                    if (this.state.sliderMaxValue !== Math.max(...targetData)) {
                        this.setState({sliderMaxValue: Math.max( ...targetData), sliderValue: Math.max( ...targetData)});                        
                    }
                    dataObj['data'] = targetData;
                    finalData.push(dataObj);
                }
            })
        }
        finalData.reverse();
        Highcharts.setOptions({
            colors: ['#058DC7', '#50B432', '#ED561B', '#DDDF00', '#24CBE5', '#64E572', '#FF9655', '#FFF263', '#6AF9C4']
        });

        Highcharts.chart('analyticsDataDiv', {

            title: {
                text: this.props.graphTitle
            },
            annotations: this.state.AnnotationLabel,
            yAxis: {
                title: {
                text: `<b>${xAxisLabel}</b>`
                },
                labels: {
                    enabled: true
                },
                min: 0,
                max: this.state.sliderValue
            },
            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'middle'
            },

            xAxis: {
                title: {
                    text: `<b>${yAxisLabel}</b>`,
                },
                tickLength: 0,
                categories: xAxisDate,
                labels: {
                    enabled: true
                }
            },

            credits: {
                enabled: false
            },

            plotOptions: {
                series: {
                    cursor: 'pointer',
                    connectNulls:true,
                    fillOpacity: 0.6,
                    label: {
                        connectorAllowed: false
                    },
                    dataLabels: {
                        enabled: false
                    },
                    events: {
                        legendItemClick: function () {
                            return false
                        }
                    },
                    marker: {
                        enabled: true        
                    }
                }
            },

            series: finalData,

            // series: [{
            //     name: 'Installation',
            //     data: [43934, 52503, 57177, 69658, 97031, 119931, 137133, 154175]
            // }, {
            //     name: 'Manufacturing',
            //     data: [24916, 24064, 29742, 29851, 32490, 30282, 38121, 40434]
            // }],

            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom'
                        }
                    }
                }]
            },

            navigation: {
                buttonOptions: {
                    verticalAlign: 'top',
                    x: -100
                }
            },

            lang: {
                contextButtonTitle: 'Click to open'
            },

            exporting: {
                buttons: {
                    contextButton: {
                        menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "downloadCSV", "downloadXLS"]
                    }
                },
                chartOptions: {
                    colors: ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000'],
                }
            }
        });
    }


    onSliderChange = (value) => {     
        this.setState({
            sliderValue: value
        },()=> this.highchartsHandler());
    }

    render() {
        let { sliderValue } = this.state
        return (
            <div className='row'>
                <div className='col-sm-auto'>
                    <Slider 
                        min={0}
                        max={this.state.sliderMaxValue}                           
                        value={sliderValue}
                        orientation="vertical"
                        onChange={(e)=>this.onSliderChange(e)}
                        tooltip={false}
                    />
                </div>
                <div className='col-sm-11'>
                {
                    this.props.loading ? "Loading..." :<div> <GraphAnnotation setAnnotationState={this.setAnnotationState}/>  <div id='analyticsDataDiv' style={{ height: '500px' }} /> </div>
                }
            </div>
        </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        loading: state.skillAcquisitionProgram.loading,
        dataAnalytics: state.skillAcquisitionProgram.skillAcquisitionProgramSingleGraphData
    };
}

export default connect(mapStateToProps, null)(TeachingDaysToMasteryGraph)


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SkillAquisition/components/Program/ProgramGraphModal/teachingDaysToMasteryGraph.js